import React, { useState } from 'react';
import { Box } from '@mui/material';
import Header from '../../Common/Header/Header';
import ServicesWrapper from '../Common/Services/page';
import { QUERY_KEYS_SIH } from '../../Common/hooks/useChartsData';
import { subtitlesMap } from '../Common/maps/subtitleMap';
import IndicatorsWrapper from './Indicators';
import TotalWrapper from './Total';
import ChartsContainer from '../../Common/ChartsContainer';
import FederalFinancingTotalsWrapper from './FederalFinancingTotals';
import ManagementTotalsWrapper from './ManagementTotals';

const titleMap = {
    0: 'Tipo de Financiamento',
    1: 'Valores de Financiamento Federal',
    2: 'Valores de Financiamento da Gestão',
    3: 'Total',
    4: 'Indicadores de Faturamento'
};

const renderContent = (activeIndex) => {
    switch (activeIndex) {
        case 0:
            return (
                <ServicesWrapper
                    module={{ sectionTitle: 'do Tipo de Financiamento' }}
                    queryConfig={{
                        key: QUERY_KEYS_SIH.FINANCING_TYPE,
                        url: 'governanceroom/dashboard/sihsus/aih/finance'
                    }}
                    subtitlesMap={subtitlesMap}
                />
            );
        case 1:
            return <FederalFinancingTotalsWrapper />;
        case 2:
            return <ManagementTotalsWrapper />;
        case 3:
            return <TotalWrapper />;
        case 4:
            return <IndicatorsWrapper />;
        default:
            return null;
    }
};

export const Revenue = ({ setActiveIndex }) => {
    const [activeIndexLocal, setActiveIndexLocal] = useState(0);

    const handleHomeClick = () => {
        if (setActiveIndex) {
            setActiveIndex(0);
        }
        setActiveIndexLocal(0);
    };

    const menus = [
        {
            title: 'Financiamento',
            onclick: () => setActiveIndexLocal(0),
            active: activeIndexLocal === 0
        },
        {
            title: 'Federal',
            onclick: () => setActiveIndexLocal(1),
            active: activeIndexLocal === 1
        },
        {
            title: 'Gestão',
            onclick: () => setActiveIndexLocal(2),
            active: activeIndexLocal === 2
        },
        {
            title: 'Total',
            onclick: () => setActiveIndexLocal(3),
            active: activeIndexLocal === 3
        },
        {
            title: 'Indicadores',
            onclick: () => setActiveIndexLocal(4),
            active: activeIndexLocal === 4
        }
    ];

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box>
                <ChartsContainer
                    title={titleMap[activeIndexLocal]}
                    className="services-container-dashboards"
                >
                    {renderContent(activeIndexLocal)}
                </ChartsContainer>
            </Box>
        </Box>
    );
};